import {lazy} from 'react';

const TeamCreate = lazy(() => import('./TeamCreate'));
const TeamList = lazy(() => import('./TeamList'));
const TeamDetails = lazy(() => import('./TeamDetails'));
const TeamUpdate = lazy(() => import('./TeamUpdate'));

export const TeamManagerConfig = [
  {
    path: '/team-manager/team-create',
    element: <TeamCreate />,
  },
  {
    path: '/team-manager/team-list',
    element: <TeamList />,
  },
  {
    path: '/team-manager/team-details/:id',
    element: <TeamDetails />,
  },
  {
    path: '/team-manager/team-update/:id',
    element: <TeamUpdate />,
  },
];
